module.exports = __webpack_public_path__ + "static/media/arrow.641d27a7.svg";